<template>
  <div
    class="custom-dropdown"
    ref="dropdownRef"
    @mouseenter="openMenu"
    @mouseleave="closeMenu"
  >
    <button class="dropdown-toggle" @click="handleItemClick(items[0])">
      {{ title }}
      <!-- <span class="dropdown-arrow" :class="{ 'rotate': isOpen }">▼</span> -->
    </button>
    <div class="dropdown-content">
       <div class="dropdown-margin" v-show="isOpen"></div>
    <div class="dropdown-menu" v-show="isOpen">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="dropdown-item"
        @click="handleItemClick(item)"
      >
        {{ displayProductName(item) }}
      </div>
    </div>
    </div>
   
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, inject } from "vue";
import { useI18n } from "vue-i18n";

// Props
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
});

// Emits
const emit = defineEmits(["item-click"]);

// 获取当前语言
const { locale } = useI18n();
const currentLanguage = inject("currentLanguage", ref("zh"));

// 响应式数据
const isOpen = ref(false);
const dropdownRef = ref(null);

// 切换菜单显示状态
const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

// 打开菜单
const openMenu = () => {
  isOpen.value = true;
};

// 关闭菜单
const closeMenu = () => {
  isOpen.value = false;
};

// 处理菜单项点击
const handleItemClick = (item) => {
  if (!item) {
    return;
  }
  emit("item-click", item);
  isOpen.value = false;
};

// 根据当前语言显示产品名称
const displayProductName = (item) => {
  // 如果是英文，优先使用英文名称，如果没有英文名称则使用中文名称
  if (locale.value === "en" || currentLanguage.value === "en") {
    return item.productNameEn || item.productName || item.text;
  }
  // 中文则使用中文名称
  return item.productName || item.text;
};

// 点击外部关闭菜单
const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

// 监听Escape键关闭菜单
const handleKeydown = (event) => {
  if (event.key === "Escape") {
    isOpen.value = false;
  }
};

// 生命周期钩子
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
  document.removeEventListener("keydown", handleKeydown);
});
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  background: none;
  border: none;
  /* 继承父元素的文字颜色 */
  color: inherit;
  text-decoration: none;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  transition: color 0.3s;
  font-weight: 500;
  outline: none;
}
.dropdown-content{
  display: flex;
  flex-direction: column;
    position: absolute;
  top: 100%;
  left: 0;
}
.dropdown-margin {
  height: 20px;
  width: 100%;
}
.dropdown-toggle::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background-color: var(--navbar-text-color, white);
  transition: width 0.3s ease-in-out;
}

.dropdown-toggle:hover::after {
  width: calc(100% - 2rem);
}

.dropdown-arrow {
  font-size: 0.6rem;
  transition: transform 0.3s ease;
}

.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {

  margin-top: 0;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 250px;
  z-index: 1000;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 0.8rem;
  outline: none;
  user-select: none;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
  color: #222;
}

/* 确保在导航栏中正确对齐 */
.custom-dropdown {
  display: flex;
  align-items: center;
  /* height: 100%; */
}
</style>
